import { render, staticRenderFns } from "./AccountsForm.vue?vue&type=template&id=822d0bfc&scoped=true&"
import script from "./AccountsForm.vue?vue&type=script&lang=js&"
export * from "./AccountsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822d0bfc",
  null
  
)

export default component.exports